export enum DomipEventType {
  NoEvent = 'NoEvent',
  Assistance = 'Assistance',
  OutOfBed = 'OutOfBed',
  Movement = 'Movement',
  Fire = 'Fire',
  Door = 'Door',
  DoorClosed = 'DoorClosed',
  DoorOpen = 'DoorOpen',
  Doorbell = 'Doorbell',
  Acoustic = 'Acoustic',
  Call = 'Call',
  ToiletCall = 'ToiletCall',
  WirelessCall = 'WirelessCall',
  InBed = 'InBed',
  InBathroom = 'InBathroom',
  InRoom = 'InRoom',
  Intruder = 'Intruder',
  IntentionOutOfBed = 'IntentionOutOfBed',
  PullOut = 'PullOut',
  OutOfRoom = 'OutOfRoom',
  WanderingDetection = 'WanderingDetection',
  Medical = 'Medical',
  Doctor = 'Doctor',
  PersonalSecurity = 'PersonalSecurity',
  EmergencyCall = 'EmergencyCall',
  Robbery = 'Robbery',
  Resuscitation = 'Resuscitation',
  ServiceRequest = 'ServiceRequest',
  Technical = 'Technical',
  OutOfBathroom = 'OutOfBathroom',
  Fall = 'Fall',
  FallDetected = 'FallDetected',
  Presence = 'Presence',
  NoPresence = 'NoPresence',
}
